import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ReplaySubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {TranslocoService} from '@ngneat/transloco';
import {TimezoneService} from '../services/timezone.service';
import {TenantsService} from '../services/tenants.service';
import {PrimeNGConfig} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class LoggedUser {

  userObservable: ReplaySubject<User>;
  userPreferences: ReplaySubject<any>;
  userTenants: any[] = [];
  userOrganizations: any[] = [];
  private readonly DEFAULT_LANGUAGE = 'es';

  constructor(private router: Router,
              private i18n: TranslocoService,
              private timezoneService: TimezoneService,
              private tenantsService: TenantsService,
              private config: PrimeNGConfig,
              private http: HttpClient) {
    this.userObservable = new ReplaySubject<User>();
    this.userPreferences = new ReplaySubject<any>();
    this.reloadUser();
  }

  public reloadUser(): void {
    this.http.get<any>('/catalog/me').toPromise().then(user => {
        this.userObservable.next(user);
        this.userTenants = user.tenants;
        this.userOrganizations = user.organizations;
        this.i18n.setActiveLang(user.language ?? this.DEFAULT_LANGUAGE);
        this.i18n.selectTranslateObject('primeng').subscribe(primengTr => {
          this.config.setTranslation(primengTr);
        });
        this.reloadPreferences();
      }
    ).catch((err) => this.userObservable.next(new User()));
  }

  public reloadPreferences(): void {
    this.http.get<any>('/catalog/me/preferences').toPromise().then(userData => {
      this.userPreferences.next(userData);
    });
  }
}

export class User {
  uuid: string;
  username: string;
  email: string;
  tenantUuid: string;
  organizationUuid: string;
  role: string;
  language: string;
  timezone: string;
  offset: string;
  portalUrl: string;
  tenants: Tenant[];
  organizations: Organization[];
  permissions: string[];
  ecommerceUser: boolean;
  root: boolean;
}

export class Tenant {
  name: string;
  uuid: string;
}

export class Organization {
  name: string;
  uuid: string;
}
